import { AuthApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useAuthAPI(): AuthApi {
  return new AuthApi(apiConfig);
}
